// theme.js
export const lightTheme = {
    body: '#eeeeee',
    text: '#363537',
    toggleBorder: '#FFF',
    gradient: 'linear-gradient(#39598A, #79D7ED)',
    customerSidebarBackground: '#2f363e',
    dashboardLogoContainer:'#ffffff',

    fcListDayTheme: '#2c3e50',
    fcListDayTextTheme:'#fefefe',

    uiHeaderTextColor:'#000000',
    uiHoverColorBackground:'#fff',
    uiCardBodyTextColor:'#000000',
    uiCardBodyBackground:'#fffffff',

    uiCardDGReportsBackground:'#fffffff',
    uiCardDGReportsTextColor:'#dedede',
    uiButtonDeleteBackgroundColor:'#EF5350',
    uiButtonDeleteTextColor:'#FFFFFF',
    uiTabBackgroundColor:"#ffffff",
    uiTabTextColor:"#000000",
    uiTabHoverColor:"#FFFFFF",
    uiCheckboxLabelColor:"#000000",
    uiButtonViewEmailBackgroundColor:'#26a69a',
    uiButtonViewEmailTextColor:'#FFFFFF',

    uiButtonEditBackgroundColor:'#ef6c00',
    uiButtonEditTextColor:'#FFFFFF',
    uiHeaderBackground:"#FFFFFF",
    uiButtonTableBackgroundColor:'#FF9800',
    uiButtonTableTextColor:'white',

    loadingPage:'#eeeeee',
    loadingPageTextColor:"",

    muiLevelColumn:'#FFFFFF',

    crowdstrikeCodeBox:'#0b54c1',

    knowledgebaseCustomerView: '#34495E',
    knowledgebaseCustomerViewBackgroundColor:"#FFFFFF",
    uiCalendarBackground:"#ffffff",
    uiCalendarText:"#000000",
    uiTabActiveColor:"#FFFFFF",
    uiTabShadowBorder:"1px solid #d4d4d5",
    uiTabMenuShadowBorder:"none",
    uiTabActiveBorderColor:"#d4d4d5",
    uiTableBackground: "#ff7f7",
    uiTableTextColor:"#000000",
    uiTableBorderColor:"",
    uiTableSectionBackground:"",
    uiFormFieldBackground:"",
    uiFormFieldTextColor:"",
    uiTabBorderColor:"",
    
    internalNoteColor:"#191970 !important",
    externalNoteColor:"#228B22 !important",
    uiAccordianBackground:"",
    uiAccordianTextColor:"",
    updateNoteColor:"",
    ckeditorToolbarBackgroundColor:"",
    ckEditorBackgroundColor:"",
    ckEditorTextColor:"",
    tinyMCEToolbarBackgroundColor:"",
    tinyMCEBackgroundColor:"",
    tinyMCETextColor:"",
    uiSecurityChartCardBackground:"",
    uiCheckBoxHoverColor:"#000000",
    uiSemanticDatePickerBackgroundColor:"",
    uiSemanticDatePickerHoverColor:"",
    uiSemanticDatePickerSelectedColor:"",
    uiCardLeftBorder:"#54C8FF"
}

export const darkTheme = {
    body: '#121212',
    text: '#eeeeee',
    toggleBorder: '#6B8096',
    gradient: 'linear-gradient(#091236, #1E215D)',
    
    customerSidebarBackground: '#1c1e20',
    dashboardLogoContainer:'#ffffff',

    fcListDayTheme: '#2b2b2b',
    fcListDayTextTheme:'#fefefe',

    uiHeaderTextColor:'#eeeeee',
    uiHoverColorBackground:'#494b54',
    uiCardBodyTextColor:'#eeeeee',
    //uiCardBodyBackground:'#1f1f1f',
    uiCardBodyBackground:'#2b2b2b',
    uiHeaderBackground:"#282828",
    uiCardDGReportsBackground:'#2b2b2b',
    uiCardDGReportsTextColor:'#eeeeee',
    uiButtonDeleteBackgroundColor:'#EF5350',
    uiButtonDeleteTextColor:'#eeeeee',
    uiTabBackgroundColor:"#2b2b2b",
    uiTabTextColor:"#eeeeee",
    uiTabHoverColor:"#e0e0e0",
    uiTabActiveColor:"#757575",
    uiCheckboxLabelColor:"#eeeeee",
    uiButtonViewEmailBackgroundColor:'#26a69a',
    uiButtonViewEmailTextColor:'#eeeeee',

    uiButtonEditBackgroundColor:'#ef6c00',
    uiButtonEditTextColor:'#eeeeee',

    uiButtonTableBackgroundColor:'#FF9800',
    uiButtonTableTextColor:'#eeeeee',

    loadingPage:'#121212',
    loadingPageTextColor:"#eeeeee !important",
    muiLevelColumn:'#FFFFFF',

    crowdstrikeCodeBox:'#0b54c1',

    knowledgebaseCustomerView: '#34495E',
    knowledgebaseCustomerViewBackgroundColor:"#eeeeee",
    uiCalendarBackground:"#eeeeee",
    uiCalendarText:"#000000",
    uiTabShadowBorder:"none",
    uiTabMenuShadowBorder:"none",
    uiTabActiveBorderColor:"transparent",
    uiTableBackground: "#414141",
    uiTableTextColor:"#eeeeee",
    uiTableBorderColor:"1px solid #626262",
    uiTableSectionBackground:"#7e7e7e",
    uiFormFieldBackground:"#1c1e20",
    uiFormFieldTextColor:"#eeeeee",
    uiTabBorderColor:"1px solid #626262",
    uiAccordianBackground:"#414141",
    uiAccordianTextColor:"#eeeeee",
    internalNoteColor:"#9090ff !important",
    externalNoteColor:"#69df69 !important",
    updateNoteColor:"#eeeeee !important",
    ckeditorToolbarBackgroundColor:"darkgray",
    ckEditorBackgroundColor:"#eeeeee",
    ckEditorTextColor:"#000000",
    tinyMCEToolbarBackgroundColor:"darkgray !important",
    tinyMCEBackgroundColor:"#eeeeee !important",
    tinyMCETextColor:"#000000 !important",
    uiSecurityChartCardBackground:"#eeeeee !important",
    uiCheckBoxHoverColor:"#eeeeee !important",
    uiSemanticDatePickerBackgroundColor:"grey",
    uiSemanticDatePickerHoverColor:"#ff851b !important",
    uiSemanticDatePickerSelectedColor:"#4f4f4f",
    uiCardLeftBorder:"#2185d0"

}